import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=995b61ee&scoped=true"
import script from "./VideoPlayer.vue?vue&type=script&lang=js"
export * from "./VideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=995b61ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b61ee",
  null
  
)

export default component.exports